import { Map } from "mapbox-gl";

const key = Symbol("mapbox-context-key");

export { key, Map };
